<template>
  <modal
    :show="true"
    :large="true"
    v-on:close="closeOccupantModal"
    :enable-event="!alertIsOpen"
  >
    <h4 slot="title">Edit Occupant</h4>
    <div class="row">
      <div class="col-xl-12">
        <div class="form-horizontal">
          <selectlist
            :options="types"
            v-model="form.type_id"
            label="Occupant Type"
            name="type"
            placeholder="Please Select"
          ></selectlist>

          <inputbox
            v-model="form.first_name"
            name="first_name"
            label="First Name"
          ></inputbox>

          <inputbox
            v-model="form.last_name"
            name="last_name"
            label="Last Name"
          ></inputbox>

          <date-of-birth
            :required="true"
            v-model="form.date_of_birth"
            :unlimited="true"
          ></date-of-birth>

          <inputbox
            v-model="form.occupation"
            name="occupation"
            label="Occupation"
          ></inputbox>

          <inputbox
            v-model="form.medical_conditions"
            name="medical_conditions"
            label="Medical Conditions"
          ></inputbox>

          <inputbox
            v-model="form.relation_to_client"
            name="relation_to_client"
            label="Relation to Client"
          ></inputbox>

          <inputbox
            v-model="form.national_insurance"
            name="national_insurance_number"
            label="National Insurance Number"
          ></inputbox>

          <selectlist
            :options="positions"
            v-model="form.position_id"
            label="Seat/Position"
            name="position"
            placeholder="Please Select"
          ></selectlist>

          <toggleswitch
            :labels="true"
            name="requires_glasses"
            label="Requires Glasses?"
            v-model="form.requires_glasses"
          ></toggleswitch>

          <toggleswitch
            :labels="true"
            name="wearing_seatbelt"
            label="Wearing Seatbelt?"
            v-model="form.wearing_seatbelt"
          ></toggleswitch>

          <fieldset>
            <legend>
              Contact Details
              <small class="text-muted"
                >- Enter the occupants contact details here</small
              >
            </legend>

            <inputbox
              v-model="form.telephone"
              name="telephone"
              label="Telephone"
            ></inputbox>

            <inputbox
              v-model="form.email_address"
              name="email"
              label="Email Address"
              type="email"
            ></inputbox>
          </fieldset>
          <fieldset>
            <legend>
              Address Details
              <small class="text-muted"
                >- Enter the occupants address details here</small
              >
            </legend>
            <address-lookup
              :address="address"
              v-on:address="setAddress"
            ></address-lookup>
          </fieldset>
        </div>
      </div>
    </div>
    <div slot="footer">
      <button
        class="btn btn-danger float-left"
        type="button"
        v-on:click="deleteOccupant"
      >
        Delete
      </button>
      <button
        type="button"
        v-on:click="closeOccupantModal"
        class="btn btn-danger"
      >
        Close
      </button>
      <button v-on:click="updateOccupant" type="button" class="btn btn-primary">
        Update Occupant
      </button>
    </div>
  </modal>
</template>
<script>
export default {
  props: {
    incident: {
      type: String,
      required: true
    },

    types: {
      type: Array,
      required: true
    },

    positions: {
      type: Array,
      required: true
    },

    occupant: {
      type: Object,
      required: true
    }
  },

  data() {
    return {
      alertIsOpen: false,
      form: new window.Form(
        {
          type_id: this.occupant.type_id,
          first_name: this.occupant.first_name,
          last_name: this.occupant.last_name,
          date_of_birth: window.DateManager.format(this.occupant.date_of_birth),
          occupation: this.occupant.occupation,
          medical_conditions: this.occupant.medical_conditions,
          relation_to_client: this.occupant.relation_to_client,
          national_insurance: this.occupant.national_insurance,
          position_id: this.occupant.position_id,
          requires_glasses: this.occupant.requires_glasses,
          wearing_seatbelt: this.occupant.wearing_seatbelt,
          telephone: this.occupant.telephone,
          email_address: this.occupant.email_address,
          address_line_one: this.occupant.address_line_one,
          address_line_two: this.occupant.address_line_two,
          city: this.occupant.city,
          postcode: this.occupant.postcode
        },
        false
      )
    };
  },

  computed: {
    address() {
      return {
        address_line_one: this.form.address_line_one,
        address_line_two: this.form.address_line_two,
        city: this.form.city,
        postcode: this.form.postcode
      };
    }
  },

  methods: {
    setAddress(address) {
      this.form.address_line_one = address.address_line_one;
      this.form.address_line_two = address.address_line_two;
      this.form.city = address.city;
      this.form.postcode = address.postcode;
    },

    deleteOccupant() {
      this.alertIsOpen = true;

      window
        .swal({
          title: 'Are you sure?',
          text: 'You cannot undo this',
          type: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Yes'
        })
        .then(confirmed => {
          if (confirmed) {
            window.Ajax.delete(
              '/incidents/' +
                this.incident +
                '/occupants/' +
                this.occupant.identifier
            )
              .then(response => {
                this.$emit('deleted', this.occupant);
              })
              .catch(error => {
                window.toastify.error(
                  'Error',
                  'Sorry, there was an error deleting the occupant.'
                );
              });
          }
        })
        .catch(error => {
          setTimeout(() => {
            this.alertIsOpen = false;
          }, 500);
        });
    },

    closeOccupantModal() {
      this.alertIsOpen = true;

      window
        .swal({
          title: 'Are you sure?',
          text: 'You will lose any unsaved changes',
          type: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Yes'
        })
        .then(confirmed => {
          if (confirmed) {
            this.$emit('close');
          }
        })
        .catch(error => {
          setTimeout(() => {
            this.alertIsOpen = false;
          }, 500);
        });
    },

    updateOccupant() {
      this.form
        .put(
          '/incidents/' +
            this.incident +
            '/occupants/' +
            this.occupant.identifier
        )
        .then(response => {
          this.$emit('updated', response);
        })
        .catch(response => {
          window.toastify.error(
            'Error',
            'Sorry, there was an error updating the incident'
          );
        });
    }
  }
};
</script>
